import {fleetManagementApi} from "../api";

export const getPackages = (params) => {
  return fleetManagementApi.get("/packages", { params });
}

export const createPackage = (data) => {
  return fleetManagementApi.post("/packages", data);
}

export const updatePackage = (packageId, data) => {
  return fleetManagementApi.put(`/packages/${packageId}`, data);
}

export const deletePackage = (packageId) => {
  return fleetManagementApi.delete(`/packages/${packageId}`);
}